import sizesTemplate from "/scripts/_partials/sizes-viewer/templates/sizes.html";
function sizesViewerDirective() {
  return {
    restrict: 'A',
    replace: true,
    templateUrl: sizesTemplate,
    controller: 'SizesViewerCtrl',
    controllerAs: 'sizesViewer',
    bindToController: true,
    scope: {
      sizes: '<?',
      sizeSelected: '=?',
      initSizes: '&',
      changeSize: '&',
      viewPopoverSize: '&',
      startSelectedSizes: '<?'
    }
  };
}
export { sizesViewerDirective };